import { state } from './state'

import * as actions from './action'

import * as mutations from './mutation'

export const procurement = {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/view/procurement/store/index.js